import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React from 'react';
import { FormattedMessage } from 'react-intl';

function MechanicRedirectModal({
  onRedirect,
  onUseDifferentAccount,
}: {
  onRedirect: () => void;
  onUseDifferentAccount: () => void;
}) {
  return (
    <Dialog
      open
      aria-labelledby="mechanic-redirect-title"
      aria-describedby="mechanic-redirect-description"
      disableEscapeKeyDown
      onClose={() => undefined}
    >
      <DialogTitle id="mechanic-redirect-title">
        <FormattedMessage id="mechanic.redirect.title" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="mechanic-redirect-description">
          <FormattedMessage id="mechanic.redirect.description" />
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onUseDifferentAccount} color="primary">
          <FormattedMessage id="mechanic.redirect.use.other.account" />
        </Button>
        <Button
          onClick={onRedirect}
          color="primary"
          variant="contained"
          autoFocus
        >
          <FormattedMessage id="mechanic.redirect.go.to.app" />
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default MechanicRedirectModal;
